import React, {cloneElement} from 'react';

import InverseProvider from '@dbk/ui-inverse';
import { IntlProvider, addLocaleData } from '@dbk-legacy/format';
import de from '@dbk-legacy/format/locale-data/de';
import en from '@dbk-legacy/format/locale-data/en';
import zh from '@dbk-legacy/format/locale-data/zh';

import { createContainer } from '@dbk-legacy/muster/react';


const get_language = (locale) => {
  const dash_index = locale.indexOf('-');
  if (dash_index >= 0) {
    return locale.substring(0, dash_index)
  }
  return locale
};


function EBankingApp({ children, style, i18n, ...otherProps}) {
  const {
    messages,
    locale
  } = i18n;

  addLocaleData([...de, ...en, ...zh]);

  return (
    <InverseProvider inverse style={style}>
      <IntlProvider {...i18n} locale={get_language(locale)} messages={messages}>
        {cloneElement(children, { ...otherProps, i18n })}
      </IntlProvider>
    </InverseProvider>
  );
}


export default createContainer({
  $queries: {
    i18n: {
      locale: true,
      messages: true
    },
    ui: {
      setDebug: { $set: 'debug' },
      history: {
        currentLocation: {
          pathname: true,
        },
      },
    },
  }
})(EBankingApp)
